export default __webpack_public_path__ + "static/cloudator-full-1-5ffdae28ed9b7705bf56fe96a6ffdba1.png";